// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__PsNxG","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__LlqAX"};